<template>
    <article class="sidebar-container">
        <section class="sidebar-wrapper" v-if="!isStoreMenu">
            <div class="gradient-line-vertical-side"></div>
            <div class="user-info">
                <a href="https://www.risingx.co.kr/DashBoard" class="router-link-active router-link-exact-active">
                    <img src="@/assets/images/layouts/sideBar/logo.svg" alt="" class="logo" >
                </a>
                <div class="setting-menu">
                    <ul class="setting-menu-list">
                        <!-- <li
                            v-for="setting in settingMenuData" :key="setting"
                            @click="settingMenuClickHandler(setting)"
                            @mouseenter="hoverHandler('enter', setting)"
                            @mouseleave="hoverHandler('leave', setting)"
                        >
                            <img
                              :src="setting.isActive || menuHover[setting.key] ? setting.activeIcon : setting.icon"
                              v-tooltip.top-start="setting?.tooltipMsg"
                            />
                        </li>
                        <li
                            @click="selectReferrals()"
                            @mouseenter="referralHover = true"
                            @mouseleave="referralHover = false"
                        >
                            <img :src="referralHover ? ReferralsActive : Referrals" alt="">
                        </li> -->
                        <li class="account__global">
                            <img :src="globalImg" alt="" @click="selectLangHandler()">
                            <div class="account__global-select" v-if="selectLang">
                                <div
                                    v-for="lang in globalMenu" :key="lang"
                                    class="account__global-img"
                                    @click="setLang(lang.key)"
                                >
                                <!-- @click="store.dispatch(`useGlobalList/langaugeClick(${lang.key}, ${useSwitchLocalePath()}`)" -->
                                    <img :src="lang.icon">
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- subscribe -->
            </div>
            <div class="scroll">
                <div class="category">
                    <CommonLoginSideMenu
                        @openContent="toggleContent()"
                        :mainMenu="mainMenu"
                        :isStore="false"
                        />

                </div>
                <div class="service">
                    <div class="share-link-wrapper">
                        <div v-for="sns in snsList" :key="sns" class="share-link-container">
                            <a
                                :href="sns.link"
                                class="share-link"
                                :class="sns.bgClass ? 'bg' : ''"
                                target="_blank"
                            >
                                <img :src="sns.icon" alt="sns.key" class="img" />
                            </a>
                        </div>
                    </div>

                    <div class="info__policy highlight highlight__500">
                        <p>
                            <a href="https://risingx-wedatalab.s3.ap-northeast-2.amazonaws.com/static/CV_Terms_and_Conditions_RisingX.pdf" target="_blank">
                                <span class="underline">{{$t('footer.terms')}}</span>
                            </a>
                            {{$t('footer.and')}}
                            <a href="https://risingx-wedatalab.s3.ap-northeast-2.amazonaws.com/static/CV_Service+Privacy+Policy_RisingX.pdf" target="_blank">
                                <span class="underline">{{$t('footer.privacyPolicy')}}</span>
                            </a>
                        </p>
                        <span class="info__contact">(c)2023-2024</span>
                        <img :src="Logo" alt="">
                    </div>
                </div>
            </div>
        </section>
    </article>
</template>

<script setup>
import CommonLoginSideMenu from '@/components/common/login/SideMenu.vue';
import Logo from '@/assets/images/layouts/sideBar/logo.svg'
import { ref, onMounted,onBeforeUnmount, defineEmits, computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n({ useScope: 'global' })
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
const selectLang = ref(false);

const store = useStore();
const snsList = ref([]);

const mainMenu = computed(()=> store.getters['useMainMenuList/mainMenuItems'])
onMounted(async () => {
  snsList.value = await store.dispatch('useSnsList/snsItems');
});
// import engIcon                from '@/assets/images/layouts/header/global/america.svg'
// import { logoutHandler }      from '~/client_api/user/user_api';
// import { DateUtil}            from '@/client_api/date/date_class';
// import { STORE_TYPES }        from "@/client_api/const"
// import { getNumberByNaN }     from "@/client_api/util.js";

// const props = defineProps({
//     userInfo   : Object,
//     isShow     : Boolean,
// });

// const menuStore              = useMainMenuList();
// const storeMenuStore         = useStoreList();
// const globalStore            = useGlobalList();
// const localePath             = useLocalePath();
// const mainMenu               = menuStore.mainMenuItems;
// const storeMenu              = ref(storeMenuStore.storeMenuItems);
// const settingMenuData        = menuStore.settingItems;
// const globalMenu             = globalStore.globalItems;
// const snsList                = useSnsList().snsItems();
// const chartSubscribeInfo     = ref(useUserStore().getChartSubscribeInfo());
// const chartSubscribeEndDate  = ref(chartSubscribeInfo.value ? DateUtil.format({date:chartSubscribeInfo.value.subsc_end_dt, format : 'YY.MM.DD'}) : '');
// const chartSubscribeType     = ref(chartSubscribeInfo.value ? chartSubscribeInfo.value.subsc_type   : 'Subscription');
// const chartSubscribePeriod   = ref(chartSubscribeInfo.value ? chartSubscribeInfo.value.period_type   : '')
// const engImg                 = globalMenu[1].icon;
// // const subscribeDate     = props.userInfo.subscribe.slice(2);
const globalMenu = computed(() => store.getters["useGlobalList/globalItems"]);
const globalImg = computed(() => globalMenu.value.find(list=> list.key == locale.value).icon);
const isMenuActive      = ref(false);
// const selectLang        = ref(false);
const foldingMenuHidden = ref(false);
const showContent       = ref(false);
const isContentActive   = ref(false);
// const userStore         = useUserStore();
// const storeType         = userStore.getUserInfo().store_type;
// const storeDscn         = userStore.getUserInfo().store_dscnt_rate;
// const storeIncome       = userStore.getUserInfo().store_income_rate;
// const router            = useRouter();
// const storeInfo         = ref(userStore.getStoreInfo);
// const referralHover     = ref(false);
// const copyDialogVisible = ref(false);
// const popupStore        = usePopupList();
// const periodType        = ref('');
// const profileClass      = ref(false);

const emit = defineEmits(["openContent", "openReferrals"]);
// const init = () => {
//     const storeTypeCode = userStore.getUserInfo().store_type;
//     storeMenu.value     = storeMenuStore.getStoreMenuList(storeTypeCode);
// }

const toggleContent = () => {
    showContent.value = !showContent.value;
    // console.log('toogleContent',showContent);
    isContentActive.value = showContent.value;
    emit("openContent", showContent.value);
}
const isStoreMenu = ref(false);
// const isStoreMenu = computed(() => {
//     return useStoreList().isStorePage;
// });

// const storeMenuList = computed(() => {
//     return storeMenu.value;
// });

// const betaClickHandler = (val) => {
//     popupStore.openBetaPopup(true);
// }

// const toCapitalize = (sub) => {
//     return sub.replace(/\b\w/g, (match) => match.toUpperCase());
// }

// const selectReferrals = () => {
//     const userData = useUserStore().userData;
//     const origin   = `${window.location.origin}`;
//     copyDialogVisible.value = true;

//     navigator.clipboard.writeText(`${origin}/signup?referral=${userData.user_ref_id}`);
//     emit("openReferrals", copyDialogVisible.value);
// }

const selectLangHandler = () => {
    selectLang.value = !selectLang.value;
}
function setLang(lang){
  locale.value = lang;
  // console.log('locale',locale.value,'mainMenuData',mainMenuData.value);
  selectLang.value = false;
  store.commit('useMainMenuList/resetMenuItems')
  cookies.set("i18n_redirected",lang)
}
const handleResize = () => {
    if (window.innerWidth <= 1024) {
        // isMenuActive.value = false;
        foldingMenuHidden.value = true;
    } else {
        // isMenuActive.value = false;
        foldingMenuHidden.value = false;
    }
};

// const settingMenuClickHandler = (item) => {
//     const router = useCustomRouter();
//     popupStore.openBetaPopup(false);
//     let path = item.route;
//     let query = {menuName : item.key};

//     if(!item.beta) {
//         popupStore.openBetaPopup(true);
//         return;
//     };

//     if(item.key === "store") {
//         if(storeType === "0") {
//             popupStore.openBetaPopup(true);
//             return;
//         }
//         query = {menuName : 'store_dashboard'};
//     }
//     if(isStoreMenu.value) {
//         path = '/dashboard'
//         query = {menuName : 'dashboard'}
//     };
//     if(item.key === "settings") {
//         if(isStoreMenu.value) {
//             path = '/settings/dashboard'
//             query = {menuName : 'settings', type: 'store', tab: 'store'}
//         } else {
//             path = '/settings/dashboard'
//             query = {menuName : 'settings', type: 'user', tab: 'default'}
//         }
//     }

//     menuStore.setMenuStatus(item.key);
//     const lang_code = useCookie('i18n_redirected').value;

//     showContent.value = !showContent.value;
//     emit("openContent", showContent.value);

//     router.push({
//         path : localePath(path, lang_code),
//         query: query,
//     })
// }

// const menuHover       = ref({});
// const menuKeyArr     = settingMenuData.map(ob => ob.key).filter(ob => ob);

// menuKeyArr.forEach(ob => {
//     menuHover.value[ob] = false;
// });

// const hoverHandler = (type, item) => {
//     switch(type) {
//         case "enter":
//             menuHover.value[item.key] = true;
//             break;
//         case "leave":
//             menuHover.value[item.key] = false;
//             break;
//     }
// }

// const notSubscribeHandler = () => {
//     router.push('/price/chart')
// }
// const subscribeUpgradeHandler = () => {
//     router.push('/price/chart')
// }

// watch(() => props.isShow, (newVal) => {
//     if(!newVal) {
//         selectLang.value = false;
//     }
// })

// watch(() => userStore?.userInfo?.store, (newVal) => {
//   let profilePath = Store;

//   if(newVal?.store_profl_image_path) {
//     profilePath = newVal?.store_profl_image_path;
//     profileClass.value = true;
//   } else {
//     profileClass.value = false;
//   }
//   storeInfo.value = {
//     ...(newVal ? newVal : {}),
//     store_profl_image_path: `${profilePath}?${DateUtil.getUnixTime()}`
//   };
// }, {immediate: true})

onMounted(() => {
    window.addEventListener('resize', handleResize);

    // switch(chartSubscribePeriod.value) {
    //     case "0" :
    //         periodType.value = `[1month]`
    //         break;
    //     case "1" :
    //         periodType.value = `[6months]`
    //         break;
    //     case "2" :
    //         periodType.value = `[12months]`
    //         break;
    //     default :
    //         periodType.value = ``
    // }
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize);
});

// init();

</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/common/login/SideBarDefault.scss';
img.logo {
}

</style>